export class JurisdictionObligation {
    id: string;
    legalEntityId: string;
    jurisdiction: string;
    vatNumber: string;
    localTaxNumber: string;
    localTradeName: string;
}